import { Component, input, InputSignal, ViewChild } from '@angular/core';
import { SupportAppointmentRequest, SupportAppointmentRequestConfirmation } from 'src/app/_provider/support/support.types';
import { AFSModalComponent, AFSToastLoadingService, AfsTooltipDirective } from "@afs-ng/overlays";
import { AfsButtonComponent } from "@afs-ng/buttons";
import { FormsModule } from '@angular/forms';
import { AssignEmployeesComponent } from "../assign-components/assign-employees/assign-employees.component";
import { SupportEmployeeService } from 'src/app/_provider/support/support-employee.service';
import { TicketEmployee } from 'src/app/_provider/tickets/ticket.service';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { DatePipe } from '@angular/common';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { CalendarPage } from 'src/app/_pages/calendar/calendar.page';
import { NavController } from '@ionic/angular';
import { AppointmentAssignRejectComponent } from "./appointment-assign-reject/appointment-assign-reject.component";
import { AppointmentAssignAcceptComponent } from "./appointment-assign-accept/appointment-assign-accept.component";

@Component({
    selector: 'appointment-assign-box',
    templateUrl: './appointment-assign-box.component.html',
    styleUrls: ['./appointment-assign-box.component.scss', '../assign.scss'],
    standalone: true,
    imports: [DatePipe, FormsModule, AFSModalComponent, AfsButtonComponent, AfsTooltipDirective, AppointmentAssignRejectComponent, AppointmentAssignAcceptComponent]
})
export class AppointmentAssignBoxComponent {

  @ViewChild("appointmentRejectModal") appointmentRejectModal!: AFSModalComponent
  @ViewChild("appointmentAssignModal") appointmentAssignModal!: AFSModalComponent
  @ViewChild("assignEmployees") assignEmployees!: AssignEmployeesComponent

  public appointmentRequest: InputSignal<SupportAppointmentRequest> = input.required()
  public disabled: InputSignal<boolean> = input(false)

  constructor(
    private supportSrv: SupportEmployeeService,
    private loadingSrv: AFSToastLoadingService,
    private feedback: FeedbackService,
    private ticketSrv: TicketEmployee.TicketService,
    private navCtrl: NavController
  ){
    
  }
  
  ngOnInit(){

  }

  public async rejectAppointmentRequest(options: SupportAppointmentRequestConfirmation){
    const result: HttpFunctionResult<boolean> = await this.loadingSrv.showLoading({
      title: "Terminanfrage ablehnen",
      message: "Die Terminanfrage wird abgelehnt...",
      backdrop: true
    }, async () => 
      await this.supportSrv.confirmSupportAppointmentRequest(this.appointmentRequest().ticketId, this.appointmentRequest().id, {
        ...options,
        workstepId: this.appointmentRequest().workstepId
      }))

    if(!result.success) return
      
    this.appointmentRejectModal.hide()
    this.ticketSrv.appointmentRequest = null

    await this.feedback.showInformationToast("Die Terminanfrage wurde erfolgreich abgelehnt.", "Terminanfrage abgelehnt")
  }

  public async acceptAppointmentRequest(options: SupportAppointmentRequestConfirmation){

    const result: HttpFunctionResult<boolean> = await this.loadingSrv.showLoading({
      title: "Terminanfrage akzeptieren",
      message: "Die Terminanfrage wird akzeptiert...",
      backdrop: true
    }, async () => await this.supportSrv.confirmSupportAppointmentRequest(this.appointmentRequest().ticketId, this.appointmentRequest().id, {
      ...options,
      appointmentDate: new Date(this.appointmentRequest().date),
      workstepId: this.appointmentRequest().workstepId
    }))

    if(!result.success) return

    this.appointmentAssignModal.hide()
    this.ticketSrv.appointmentRequest = null

    await this.feedback.showInformationToast("Die Terminanfrage wurde erfolgreich akzeptiert und zugewiesen.", "Terminanfrage akzeptiert")
  }

  public async openCalendar(){
    if(!window.matchMedia("(max-width: 1050px)").matches) await this.feedback.showModal({
      component: CalendarPage,
      componentProps: {isModal: true},
      backdropDismiss: true,
      cssClass: "calendar-modal"
    })
    else await this.navCtrl.navigateForward('tabs/calendar-mobile') 
  }
}
